"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function NavigationHandler() {
  const pathname = usePathname();

  useEffect(() => {
    if (window.location.hash) return;
    document.documentElement.style.scrollBehavior = "auto";
    document.body.style.scrollBehavior = "auto";
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    const t = setTimeout(() => {
      document.documentElement.style.scrollBehavior = "";
      document.body.style.scrollBehavior = "";
    }, 100);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
